















import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import CommentHistory from '@getaccept/lib-shared/src/contextual-commenting/components/CommentHistory.vue';
import type { CurrentUser } from '@getaccept/lib-shared/src/contextual-commenting/types/current-user';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { CreateReplyInput } from '@getaccept/lib-shared/src/contextual-commenting/types/create-reply-input';
import type { UpdateCommentDto } from '@getaccept/lib-shared/src/contextual-commenting/types/update-comment-dto';
import { recipient } from '@getaccept/lib-shared/src/mocks/mock';
import { useContextualComments } from '../composables/contextual-comments.composable';

export default defineComponent({
  components: {
    CommentHistory,
  },
  props: {
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      required: true,
    },
    recipients: {
      type: Array as PropType<Recipient[]>,
      required: true,
    },
    sender: {
      type: Object as PropType<User>,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const commentsComposable = useContextualComments();

    const comments = computed(() => commentsComposable.comments.value);

    const currentUser = computed<CurrentUser>(() => ({
      recipientId: props.recipient.id,
      name: props.recipient.fullName,
      thumbUrl: props.recipient.thumbUrl,
    }));

    const selectedCommentId = computed(() => commentsComposable.selectedCommentId.value);

    const handleSelectComment = (id: string) => {
      commentsComposable.selectComment(id, recipient.id);
    };

    const handleUpdateComment = (payload: Partial<UpdateCommentDto>) => {
      commentsComposable.updateComment(payload);
    };

    const handleCreateReply = (payload: CreateReplyInput) => {
      commentsComposable.createReply(payload, recipient.id);
    };

    return {
      comments,
      currentUser,
      handleCreateReply,
      handleSelectComment,
      handleUpdateComment,
      selectedCommentId,
    };
  },
});
